module.exports = __webpack_public_path__ + "static/media/chevron-up.57c5566b.svg";